// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2nBk-","detailsBorder":"styles_detailsBorder__10ZYx"};